import { useState, useEffect } from 'react';
import { MyStorePage } from './seller/MyStorePage';
import { DesktopMyStorePage } from './desktop/DesktopMyStorePage';

export function ResponsiveMyStorePage() {
  const [isMobile, setIsMobile] = useState(true);

  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth < 1024);
    };

    checkScreenSize();
    window.addEventListener('resize', checkScreenSize);
    
    return () => window.removeEventListener('resize', checkScreenSize);
  }, []);

  return isMobile ? <MyStorePage /> : <DesktopMyStorePage />;
}